export const NAVIGATION = 'NAVIGATION';
export const REDIRECT_MAINTENANCE = 'REDIRECT_MAINTENANCE';

export interface NavState {
  location: string;
  maintenance: boolean;
  previousLocation: string;
  query: { [key: string]: string };
  redirection?: string;
}

interface NavigationAction {
  type: typeof NAVIGATION;
  context: PageJS.Context;
}

interface RedirectMaintenanceAction {
  type: typeof REDIRECT_MAINTENANCE;
  enabled: boolean;
}

export type NavActions = NavigationAction | RedirectMaintenanceAction;
